module.exports = __webpack_public_path__ + "img/close.b94e7ae5.svg";